import { Route, Routes, Navigate} from 'react-router-dom'
import Users from './components/Users'
import Settings from './components/Settings'
import APIAccesses from './components/APIAccesses'
import APIAccess from './components/APIAccess'
import APIAccessRequests from './components/APIAccessRequests'
import ContentInterventions from './components/ContentInterventions'
import ContentBlocklists from './components/ContentBlocklists'
import PromptClassifications from './components/PromptClassifications'
import PromptInterventionSimilarities from './components/PromptInterventionSimilarities'
import FilteredContent from './components/FilteredContent'
import ContentIslamic from './components/ContentIslamic'
import ContentSafetyScores from './components/ContentSafetyScores'

import { AdminLayout } from '../../layouts/AdminLayout'

const AdminPage = () => {
  
  return (
    <Routes>
      <Route element={<AdminLayout />}>
        <Route path="users" element={<Users />}/>
        <Route path="settings" element={<Settings />}/>
        <Route path="api-accesses" element={<APIAccesses/>}/>
        <Route path="api-accesses/:projectId" element={<APIAccess/>}/>
        <Route path="api-access-requests" element={<APIAccessRequests/>}/>
        <Route path="content-moderation/interventions" element={<ContentInterventions/>}/>
        <Route path="content-moderation/blocklists/:type" element={<ContentBlocklists/>}/>
        <Route path="content-moderation/islamic" element={<ContentIslamic/>}/>
        <Route path="content-analytics/prompt-classifications" element={<PromptClassifications/>}/>
        <Route path="content-analytics/filtered-content" element={<FilteredContent/>}/>
        <Route path="content-analytics/prompt-intervention-similarities" element={<PromptInterventionSimilarities/>}/>
        <Route path="content-analytics/content-safety-scores" element={<ContentSafetyScores/>}/>
        <Route index element={<Navigate to="api-accesses" />} />
        <Route path="*" element={<Navigate to="/error/404" />}/>
      </Route>
    </Routes>
  )
}

export default AdminPage
